<template>
  <div>
    <b-container>
      <b-row class="mt-md-5 no-gutters ml-0">
        <b-col class="d-none d-sm-block ml-0" cols="1">
          &nbsp;
        </b-col>
        <b-col class="mt-2 mt-md-5 ml-2">
          <h4>Willkommen im Zahlungsportal der evm.</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3 d-none d-sm-block" cols="1">
          &nbsp;
        </b-col>
        <b-col class="mt-5 ml-2">
          &nbsp;Bitte geben Sie Ihre Kundennummer ein:
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3 d-none d-sm-block" cols="1">
          &nbsp;
        </b-col>
        <b-col class="ml-2 text-custno">
          &nbsp;(Ihre Kundennummer finden Sie z. B. auf Ihrer letzten Rechnung oder auf Ihrem Begrüßungsschreiben.)
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3 d-none d-sm-block" cols="1">
          &nbsp;
        </b-col>
        <b-col class="mt-3 mb-3 ml-2">
          <b>&nbsp;Kundennummer:</b>
        </b-col>
      </b-row>
      <b-row class="no-gutters ml-0">
        <b-col class="mt-3 d-none d-sm-block ml-0" cols="1">
          &nbsp;
        </b-col>
        <b-col class="ml-0">
          <b-container class="ml-0">
            <b-row class="no-gutters ml-0">
              <b-col class="ml-0 col-2 col-lg-1">
                <b-form-input
                  id="case_no_0"
                  ref="case_no_0"
                  type="text"
                  v-model="custNo[0]"
                  maxlength="3"
                  @focus="$event.target.select()"
                  @input="formatter(0)"
                ></b-form-input>
              </b-col>
              <b-col class="col-auto mt-1">
                &nbsp;.&nbsp;
              </b-col>
              <b-col class="ml-0 col-2 col-lg-1">
                <b-form-input
                  id="case_no_1"
                  ref="case_no_1"
                  type="text"
                  v-model="custNo[1]"
                  maxlength="3"
                  @focus="$event.target.select()"
                  @input="formatter(1)"
                ></b-form-input>
              </b-col>
              <b-col class="col-auto  mt-1">
                &nbsp;.&nbsp;
              </b-col>
              <b-col class="ml-0 col-2 col-lg-1">
                <b-form-input
                  id="case_no_2"
                  ref="case_no_2"
                  type="text"
                  v-model="custNo[2]"
                  maxlength="3"
                  @focus="$event.target.select()"
                  @input="formatter(2)"
                ></b-form-input>
              </b-col>
              <b-col class="col-auto  mt-1">
                &nbsp;-&nbsp;
              </b-col>
              <b-col class="ml-0 col-2 col-lg-1">
                <b-form-input
                  id="case_no_3"
                  ref="case_no_3"
                  type="text"
                  v-model="custNo[3]"
                  maxlength="4"
                  @focus="$event.target.select()"
                  @input="formatter(3)"
                  @keyup.enter="validateAndSave()"
                ></b-form-input>
              </b-col>
              <div class="w-100 pt-2 d-sm-none"></div>
              <b-col class="col-12 col-sm-auto pt-2 pl-sm-3 pt-sm-0 mb-5">
                <b-button @click="validateAndSave()">Senden</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-1  d-none d-sm-block" cols="1">
          &nbsp;
        </b-col>
        <b-col class="mt-1 ml-3">
          <div v-if="msg" class="text-danger">
            {{ msg }}
          </div>
        </b-col>
      </b-row>
    </b-container>
    <cookie-consent
      message="Unsere Webseite verwendet Cookies. Informationen zu den verwendeten Cookies und weitere datenschutzrechtliche Hinweise finden Sie in unseren"
      linkLabel="Datenschutzhinweisen."
      href="https://www.evm.de/evm/Homepage/Impressum/#datenschutz"
      buttonLabel="Akzeptieren"
    />
  </div>
</template>

<script>

import { ApiCalls } from '../scripts/ApiCalls'

export default {
  name: 'Start',
  components: { },
  data () {
    return {
      custNo: [],
      state: [],
      msg: ''
    }
  },
  mounted () {
    localStorage.custNo = null
  },
  methods: {
    formatter (i) {
      this.custNo[i] = this.custNo[i].replace(/[\W\D\s._-]+/g, '')
      if (i < 3 && this.custNo[i].length === 3) {
        this.$refs['case_no_' + (i + 1)].focus()
      }
    },
    validateAndSave () {
      let regex = /^[\d]{3}$/
      let regexDeb = /^[\d]{1,4}$/
      let submit = true
      this.msg = ''
      this.state = []
      if (this.custNo && this.custNo.length === 4) {
        for (let i = 0; i < 3; i++) {
          if (this.custNo[i].match(regex)) {
            this.state[i] = true
          } else {
            this.state[i] = false
            submit = false
          }
        }

        if (this.custNo[3].match(regexDeb)) {
          this.state[3] = true
        } else {
          this.state[3] = false
        }
      }

      if (submit) {
        let custNo = this.custNo[0] + '.' +
            this.custNo[1] + '.' +
            this.custNo[2] + '-' +
            this.custNo[3]

        // let self = this

        ApiCalls.login(custNo).then(res => {
          console.log(res)
          if (res.headers.authorization) {
            localStorage.authKey = res.headers.authorization
            localStorage.custNo = custNo
            this.$router.replace({ name: 'paymentselect' })
          } else {
            this.msg = 'Kundennummer nicht gefunden. Bitte überprüfem Sie Ihre Eingabe oder wenden Sie sich an Ihren Kundenbetreuer'
          }
        }).catch(err => {
          console.log(err)
          this.msg = 'Kundennummer nicht gefunden. Bitte überprüfem Sie Ihre Eingabe oder wenden Sie sich an Ihren Kundenbetreuer'
        })
      } else {
        this.msg = 'Fehlerhafte Kundennummer. Bitte überprüfen Sie Ihre Eingabe.'
      }
    }
  }
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }
  .btn-evm-orange:hover {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }
  .form-control {
    padding-right:1px !important;
    padding-left:5px !important;
  }
</style>

<style lang="scss">
  /*
    CookieConsent
  */
  @import "../scss/cookie-consent";
  @import "../scss/cookie-consent-bottom";
  @import "../scss/cookie-consent-transition";
  /*
    Bootstrap
  */
  @import "~bootstrap/scss/bootstrap";
</style>
